import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-arrefund-range',
  templateUrl: './arrefund-range.component.html',
  styleUrls: [],
  standalone: false
})
export class ARRefundRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
